export const approval_1 = require('./approval_1.png')
export const disapproval_1 = require('./disapproval_1.png')
